
import { createSlice } from "@reduxjs/toolkit";
import toast from "react-hot-toast";


const CartSlice = createSlice({
    name: "Cart",
    initialState: {
        loading: false,
        cart: localStorage.getItem("cart") ? JSON.parse(localStorage.getItem("cart")) : [],
        openCart:false,
        cartTotalAmount:0,
        cartTotalQty:0
    },

    reducers: {
        addtoCart: (state, action) => {
            const itemIndex = state.cart.findIndex((item) => item.id === action.payload.id);
            if (itemIndex >= 0) {
                state.cart[itemIndex].cartQty += 1;
                toast.success(`Item QTY Increased`)
            } else {
                const temp = { ...action.payload, cartQty: 1 }
                state.cart.push(temp)
                toast.success(`${action.payload.title} added to cart`)
            }
            localStorage.setItem("cart", JSON.stringify(state.cart))
        },
        removeFromCart: (state, action) => {
            state.cart = state.cart.filter(filterdItem => {
                return filterdItem.id !== action.payload
            })
            localStorage.setItem("cart", JSON.stringify(state.cart));
            toast.success(`${action.payload} removed from Cart`)
        },
        increaseItemQTY: (state, action) => {
            const itemIndex = state.cart.findIndex((item) => item.id === action.payload);
            if (itemIndex >= 0) {
                state.cart[itemIndex].cartQty += 1;
            }  
            localStorage.setItem("cart", JSON.stringify(state.cart))
            toast.success(`Item QTY Increased`)
        },
        decreaseItemQTY: (state, action) => {
            const itemIndex = state.cart.findIndex((item) => item.id === action.payload);
            if (state.cart[itemIndex].cartQty > 1) {
                state.cart[itemIndex].cartQty -= 1;
            }  
            toast.success(`Item QTY Decreased`)
        },
        clearCart: (state, action) => { 
            state.cart = []
            localStorage.setItem("cart", JSON.stringify(state.cart));
            toast.success(`Clear Cart`)
        },
        showCart:(state,action)=>{
            state.openCart = action.payload
        },
        GetTotal:(state,action)=>{
            let {totalAmount,totalQty} = state.cart.reduce((cartTotal,cartItem)=>{ ;
            const {price,cartQty} = cartItem;
            const totalPrice = price*cartQty;
            cartTotal.totalAmount += totalPrice
            cartTotal.totalQty += cartQty
            return cartTotal;
            },{
                totalAmount:0,
                totalQty:0
            });
            state.cartTotalAmount = totalAmount;
            state.cartTotalQty = totalQty
        },
        
    }
});
export const { addtoCart, removeFromCart, increaseItemQTY, decreaseItemQTY, clearCart ,showCart,GetTotal} = CartSlice.actions;
export default CartSlice.reducer; 
